document.addEventListener("DOMContentLoaded", function () {
  // 用于存储每个刻字框对应的字体隐藏字段选择器（避免重复创建）
  // 使用 WeakMap 以便在 DOM 节点被移除时自动清理
  const fontHiddenFieldMap = new WeakMap();

  const observer = new MutationObserver((mutations, obs) => {
    // 查找所有未初始化的刻字输入框
    const visibleInputs = document.querySelectorAll('input.ymq-input-text[name*="Engraving"]');
    
    visibleInputs.forEach(visibleInput => {
      // 跳过已经初始化过的输入框
      if (visibleInput.dataset.engravingInitialized === "true") return;

      const engravingBox = visibleInput.closest('.ymq-options-box');
      if (!engravingBox) return;

      // 标记这个输入框已初始化
      visibleInput.dataset.engravingInitialized = "true";

      const inputWrapper = visibleInput.closest('.ymq-option-text-input-wrapper');
      
      // 为每个输入框生成唯一标识（用于创建唯一的控制包装器和隐藏字段）
      const uniqueId = `engraving_${Math.random().toString(36).substr(2, 8)}_${Date.now()}`;
      visibleInput.setAttribute('data-engraving-unique-id', uniqueId);

      // -------------------------
      // 图案配置
      // -------------------------
      const patternConfigs = [
        { name: 'heart', symbol: '❤', displayText: '❤', engraveText: '❤' },
        { name: 'crown', symbol: '♛', displayText: '♛', engraveText: '♛' },
        { name: 'flower', symbol: '🌸', displayText: '🌸', engraveText: '🌸' },
        { name: 'paw', symbol: '🐾', displayText: '🐾', engraveText: '🐾' },
        { name: 'infinity', symbol: '∞', displayText: '∞', engraveText: '∞' },
        { name: 'sparkles', symbol: '✨', displayText: '✨', engraveText: '✨' },
        { name: 'star', symbol: '⭐', displayText: '⭐', engraveText: '⭐' },
        { name: 'moon', symbol: '🌙', displayText: '🌙', engraveText: '🌙' },
        { name: 'sun', symbol: '☀', displayText: '☀', engraveText: '☀' },
        { name: 'mercury', symbol: '☿', displayText: '☿', engraveText: '☿' },
        { name: 'venus', symbol: '♀', displayText: '♀', engraveText: '♀' },
        { name: 'mars', symbol: '♂', displayText: '♂', engraveText: '♂' },
        { name: 'jupiter', symbol: '♃', displayText: '♃', engraveText: '♃' },
        { name: 'saturn', symbol: '♄', displayText: '♄', engraveText: '♄' },
        { name: 'uranus', symbol: '♅', displayText: '♅', engraveText: '♅' },
        { name: 'neptune', symbol: '♆', displayText: '♆', engraveText: '♆' },
        { name: 'pluto', symbol: '♇', displayText: '♇', engraveText: '♇' }
      ];

      // -------------------------
      // 为当前输入框创建专属的隐藏字段（存储字体信息）
      // -------------------------
      let fontHiddenInput = fontHiddenFieldMap.get(visibleInput);
      if (!fontHiddenInput) {
        fontHiddenInput = document.createElement("input");
        fontHiddenInput.type = "hidden";
        fontHiddenInput.name = "properties[Text_Style]";
        fontHiddenInput.value = "";
        fontHiddenInput.setAttribute('data-engraving-owner', uniqueId);
        
        // 插入到刻字输入框附近（父元素内部）
        if (visibleInput.parentNode) {
          visibleInput.parentNode.appendChild(fontHiddenInput);
        } else if (engravingBox) {
          engravingBox.appendChild(fontHiddenInput);
        }
        fontHiddenFieldMap.set(visibleInput, fontHiddenInput);
      }

      // -------------------------
      // 创建统一容器（使用唯一ID）
      // -------------------------
      const controlWrapperId = `engravingControlWrapper_${uniqueId}`;
      let controlWrapper = document.getElementById(controlWrapperId);
      
      if (!controlWrapper) {
        controlWrapper = document.createElement("div");
        controlWrapper.id = controlWrapperId;
        controlWrapper.className = "engraving-control-wrapper";
        controlWrapper.style.cssText = "display:none; margin-bottom:15px;";
      } else {
        // 如果已经存在，清空内容但保留容器（避免重复添加）
        controlWrapper.innerHTML = '';
      }

      // 预览容器
      const previewId = `engravingLivePreview_${uniqueId}`;
      const previewContainer = document.createElement("div");
      previewContainer.id = previewId;
      previewContainer.className = "product-surface";
      previewContainer.style.cssText = `
        width: 100%;
        height: 50px;
        position: relative;
        border: none;
        border-radius: 8px;
        margin-bottom: 12px;
        overflow: hidden;
        box-shadow: inset 0 0 20px rgba(0,0,0,0.1);
      `;
      
      const previewTextId = `engravingPreviewText_${uniqueId}`;
      const previewTextEl = document.createElement("div");
      previewTextEl.id = previewTextId;
      previewTextEl.className = "engraved-text";
      previewTextEl.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        max-width: 80%;
        text-align: center;
        word-break: break-word;
        line-height: 1.4;
        font-weight: 600;
      `;
      previewContainer.appendChild(previewTextEl);
      controlWrapper.appendChild(previewContainer);

      // 控制选项容器 - 字体选择
      const controlsRow = document.createElement("div");
      controlsRow.style.cssText = `
        display: flex;
        gap: 12px;
        align-items: center;
        margin-bottom: 12px;
        flex-wrap: wrap;
      `;

      const fontButtonContainer = document.createElement("div");
      fontButtonContainer.style.cssText = `
        display: flex;
        gap: 6px;
        flex-wrap: wrap;
      `;

      const fontOptions = [
        { value: "Inter", label: "Inter", className: "font-inter" },
        { value: "Charm", label: "Charm", className: "font-charm" },
        { value: "Bodoni Moda", label: "Bodoni", className: "font-bodoni" },
        { value: "League Gothic", label: "Gothic", className: "font-league-gothic" }
      ];

      let currentFont = "Inter";

      fontOptions.forEach(font => {
        const fontBtn = document.createElement("button");
        fontBtn.type = "button";
        fontBtn.textContent = font.label;
        fontBtn.dataset.font = font.value;
        fontBtn.className = `font-btn ${font.className}`;
        fontBtn.style.cssText = `
          padding: 6px 10px;
          border: 2px solid #ddd;
          background: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 12px;
          transition: all 0.2s ease;
          min-width: 50px;
        `;

        if (font.value === "Inter") {
          fontBtn.style.borderColor = "#000";
          fontBtn.style.background = "#000";
          fontBtn.style.color = "#fff";
        }

        fontBtn.addEventListener("click", function () {
          fontButtonContainer.querySelectorAll('.font-btn').forEach(btn => {
            btn.style.borderColor = "#ddd";
            btn.style.background = "white";
            btn.style.color = "#333";
          });
          this.style.borderColor = "#000";
          this.style.background = "#000";
          this.style.color = "#fff";
          currentFont = font.value;
          updateEngravingDisplay();
        });

        fontButtonContainer.appendChild(fontBtn);
      });

      controlsRow.appendChild(fontButtonContainer);
      controlWrapper.appendChild(controlsRow);

      // 符号按钮容器（可滚动/换行）
      const iconContainer = document.createElement("div");
      iconContainer.style.cssText = `
        display: flex;
        gap: 6px;
        margin-top: 8px;
        flex-wrap: wrap;
        align-items: center;
      `;

      patternConfigs.forEach(pattern => {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.textContent = pattern.displayText;
        btn.dataset.symbol = pattern.symbol;
        btn.style.cssText = `
          padding: 8px 12px;
          border: 1px solid #ddd;
          background: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
          transition: all 0.2s ease;
          min-width: 44px;
          min-height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
        `;

        btn.addEventListener("mouseenter", function() {
          this.style.borderColor = "#000";
          this.style.transform = "translateY(-1px)";
          this.style.background = "#f8f8f8";
        });

        btn.addEventListener("mouseleave", function() {
          this.style.borderColor = "#ddd";
          this.style.transform = "translateY(0)";
          this.style.background = "white";
        });

        btn.addEventListener("click", function () {
          insertAtCursor(visibleInput, pattern.symbol);
          updateEngravingDisplay();
        });
        iconContainer.appendChild(btn);
      });

      controlWrapper.appendChild(iconContainer);

      // 插入到页面（每个输入框独立容器）
      if (inputWrapper) {
        // 避免重复插入
        if (!inputWrapper.parentNode.querySelector(`#${controlWrapperId}`)) {
          inputWrapper.insertAdjacentElement('beforebegin', controlWrapper);
        }
      } else if (engravingBox.firstChild) {
        if (!engravingBox.querySelector(`#${controlWrapperId}`)) {
          engravingBox.insertBefore(controlWrapper, engravingBox.firstChild);
        }
      }

      // -------------------------
      // 工具函数
      // -------------------------
      function insertAtCursor(input, text) {
        const start = input.selectionStart;
        const end = input.selectionEnd;
        const value = input.value;
        input.value = value.substring(0, start) + text + value.substring(end);
        input.selectionStart = input.selectionEnd = start + text.length;
        input.focus();
      }

      // 处理特殊字符显示
      function formatEngravingText(text) {
        const emojiMap = {
          '🌸': '<span class="emoji-small">🌸</span>',
          '🐾': '<span class="emoji-small">🐾</span>',
          '❤': '<span class="emoji-normal">❤</span>',
          '♛': '<span class="emoji-normal">♛</span>',
          '∞': '<span class="emoji-normal">∞</span>',
          '✨': '<span class="emoji-normal">✨</span>',
          '⭐': '<span class="emoji-normal">⭐</span>',
          '🌙': '<span class="emoji-normal">🌙</span>',
          '☀': '<span class="emoji-normal">☀</span>',
          '☿': '<span class="emoji-normal">☿</span>',
          '♀': '<span class="emoji-normal">♀</span>',
          '♂': '<span class="emoji-normal">♂</span>',
          '♃': '<span class="emoji-normal">♃</span>',
          '♄': '<span class="emoji-normal">♄</span>',
          '♅': '<span class="emoji-normal">♅</span>',
          '♆': '<span class="emoji-normal">♆</span>',
          '♇': '<span class="emoji-normal">♇</span>'
        };
        
        let formattedText = text;
        Object.keys(emojiMap).forEach(emoji => {
          formattedText = formattedText.replace(new RegExp(emoji.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), emojiMap[emoji]);
        });
        return formattedText;
      }

      function updateHiddenFieldState(hasContent) {
        if (fontHiddenInput) {
          fontHiddenInput.value = hasContent ? currentFont : "";
        }
      }

      const updateEngravingDisplay = function() {
        const text = visibleInput.value.trim();
        
        if (!text) {
          controlWrapper.style.display = "none";
          updateHiddenFieldState(false);
          return;
        }

        controlWrapper.style.display = "block";
        updateHiddenFieldState(true);

        // 更新预览
        const previewText = document.getElementById(previewTextId);
        if (previewText) {
          previewText.innerHTML = formatEngravingText(text);
          previewText.style.fontFamily = currentFont;
        }
      };

      // 保存更新函数到输入框的扩展属性，以便后续清理（可选）
      visibleInput._updateEngravingDisplay = updateEngravingDisplay;
      
      // 监听输入事件
      visibleInput.removeEventListener('input', visibleInput._inputHandler); // 避免重复绑定
      const inputHandler = function() {
        updateEngravingDisplay();
      };
      visibleInput.addEventListener('input', inputHandler);
      visibleInput._inputHandler = inputHandler;

      // 初始化显示
      updateEngravingDisplay();
    });
  });

  // 开始观察 DOM 变化
  observer.observe(document.body, { childList: true, subtree: true });
});